<template>
  <div>
    <div class="page-wrapper">
      <div class="page-content-wrapper">
        <div class="shadow-btm">
          <div class="row col-lg-6 col-sm-6 my-auto">
            <a
              class="pr-2 text-dark cursor-pointer"
              v-on:click="$router.push('/success-stories')"
              ><span class="font-24 mr-2"
                ><img src="/images/back-arrow.svg" width="18"
              /></span>
            </a>
            <h4 class="mb-0 lg-bld">
              {{ this.uuid ? "View" : "Add" }}
              {{ detail.status == "REJECTED" ? "Rejected" : "Success" }} Stories
            </h4>
          </div>
        </div>
        <div class="page-content">
          <div class="col-lg-10 col-sm-10 mx-auto">
            <div class="card p-4">
              <Form @submit="save()">
                <div class="row">
                  <div class="col-lg-12 col-sm-12 text-center mb-4">
                    <img
                      :src="
                        detail.image && detail.image != null
                          ? detail.image
                          : '/images/placeholder.png'
                      "
                      id="preview"
                      class="img-fluid"
                      style="width: 200px; height: 200px"
                    /><br />
                    <div id="msg"></div>
                    <div id="image-form" style="margin: 0 auto; width: 90px">
                      <input
                        type="file"
                        name="img[]"
                        class="file"
                        id="pickFile"
                        @change="selectedFile($event)"
                        accept="image/*"
                        style="display: none"
                      />
                      <div class="input-group my-1">
                        <input
                          type="text"
                          class="form-control"
                          disabled
                          placeholder="Upload File"
                          id="file"
                          style="display: none"
                        />
                        <div class="changePic" style="bottom: -25px">
                          <label for="pickFile"> Upload Photo</label>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6">
                    <div class="row">
                      <div class="col-lg-12 col-sm-12 form-group">
                        <h5>Groom</h5>
                      </div>

                      <div class="col-lg-12 col-sm-12 form-group" v-if="!uuid">
                        <label>Search Groom</label>

                        <div class="has-search">
                          <i
                            class="fa fa-search"
                            style="position: absolute; margin: 10px"
                            aria-hidden="true"
                          ></i>
                          <Field
                            type="text"
                            placeholder="Search First Name / Last Name / Registration No."
                            name="number"
                            v-model="groom_search_data"
                            rules="required:Groom"
                            :validateOnInput="true"
                            v-slot="{ field }"
                          >
                            <Multiselect
                              mode="single"
                              trackBy="name"
                              label="name"
                              valueProp="uuid"
                              placeholder="Search First Name / Last Name / Registration No."
                              searchable="true"
                              object="true"
                              v-model="groom_search_data"
                              :options="groom_List"
                              :disabled="uuid"
                              v-bind="field"
                              @select="setGroom(groom_search_data)"
                              @search-change="
                                searchByRefferenceId($event, 'GROOM')
                              "
                            >
                              <template v-slot:option="{ option }">
                                {{ option.name }}
                              </template>
                            </Multiselect>
                          </Field>
                          <ErrorMessage name="number" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Registration ID</label>

                          <Field
                            type="text"
                            name="registration_no"
                            class="form-control"
                            placeholder="Registration No."
                            v-model="groom.registration_no"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>First Name</label>

                          <Field
                            type="text"
                            name="name"
                            class="form-control"
                            placeholder="First Name"
                            v-model="groom.first_name"
                            disabled
                          />
                        </div>
                      </div>

                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Last Name</label>

                          <Field
                            type="text"
                            name="last_name"
                            class="form-control"
                            placeholder="Last Name"
                            v-model="groom.last_name"
                            disabled
                          />
                        </div>
                      </div>

                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Family Residence City</label>

                          <Field
                            type="text"
                            name="city"
                            class="form-control"
                            placeholder="Family Residence City"
                            v-model="groom.city"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-6 col-sm-6">
                    <div class="row">
                      <div class="col-lg-12 col-sm-12 form-group">
                        <h5>Bride</h5>
                      </div>

                      <div class="col-lg-12 col-sm-12 form-group" v-if="!uuid">
                        <label>Search Bride</label>

                        <div class="has-search">
                          <i
                            class="fa fa-search"
                            style="position: absolute; margin: 10px"
                            aria-hidden="true"
                          ></i>
                          <Field
                            type="text"
                            placeholder="Search First Name / Last Name / Registration No."
                            name="Bride_"
                            v-model="bride_search_data"
                            rules="required:Bride"
                            :validateOnInput="true"
                            v-slot="{ field }"
                          >
                            <Multiselect
                              ref="bride"
                              mode="single"
                              trackBy="name"
                              label="name"
                              valueProp="name"
                              placeholder="Search First Name / Last Name / Registration No."
                              searchable="true"
                              object="true"
                              v-model="bride_search_data"
                              :options="bride_List"
                              @select="setBride(bride_search_data)"
                              @search-change="
                                searchByRefferenceId($event, 'BRIDE')
                              "
                              v-bind="field"
                            >
                              <template v-slot:option="{ option }">
                                {{ option.name }}
                              </template>
                            </Multiselect>
                          </Field>
                          <ErrorMessage name="Bride_" class="text-danger" />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Registration ID</label>

                          <Field
                            type="text"
                            name="registration_no1"
                            class="form-control"
                            placeholder="Registration No."
                            v-model="bride.registration_no"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>First Name</label>
                          <Field
                            type="text"
                            name="name1"
                            class="form-control"
                            placeholder="First Name"
                            v-model="bride.first_name"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Last Name</label>
                          <Field
                            type="text"
                            name="last_name1"
                            class="form-control"
                            placeholder="Last Name"
                            v-model="bride.last_name"
                            disabled
                          />
                        </div>
                      </div>
                      <div class="col-lg-12 col-sm-12">
                        <div class="form-group">
                          <label>Family Residence City</label>

                          <Field
                            type="text"
                            name="city1"
                            class="form-control"
                            placeholder="Family Residence City"
                            v-model="bride.city"
                            disabled
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-12 col-sm-12">
                    <div class="form-group">
                      <label>Comment</label>
                      <Field
                        as="textarea"
                        name="comment"
                        class="form-control"
                        placeholder="Comment here"
                        :disabled="uuid"
                        v-model="detail.comment"
                      />
                    </div>
                  </div>
                  <div
                    class="col-lg-12 col-sm-12 text-center mt-2"
                    v-if="detail.status == 'PENDING'"
                  >
                    <button
                      type="button"
                      class="fill-btn px-4 ml-3"
                      v-on:click="showAcceptPopup()"
                    >
                      Accept
                    </button>
                    <button
                      type="button"
                      class="fil-btn px-4 ml-3"
                      id="cancel-button"
                      v-on:click="showRejectPopup()"
                    >
                      Reject
                    </button>
                    <button
                      type="button"
                      class="fil-btn px-4 ml-3"
                      id="cancel-button"
                      v-on:click="$router.go(-1)"
                    >
                      Back
                    </button>
                  </div>
                  <!-- v-if="detail.status != 'PENDING'" -->
                  <div class="col-lg-12 col-sm-12 text-center mt-3">
                    <!-- v-if="!uuid" -->
                    <button id="save-button" class="fill-btn px-4 ml-3">
                      Save
                    </button>
                    <button
                      v-if="detail.status != 'PENDING'"
                      type="button"
                      class="fil-btn px-4 ml-3"
                      id="cancel-button"
                      v-on:click="$router.go(-1)"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </Form>
            </div>
          </div>
          <DeleteModal @remove="accept($event)" ref="acceptModal" />
        </div>
      </div>
    </div>
  </div>
  <DeleteModal @remove="deleteRecord($event)" ref="rejectModal" />
  <!-- Add Success Stories end -->
</template>
<script>
import Multiselect from "@vueform/multiselect";
// import TextModal from "@/components/TextModal";
import { Form, Field, ErrorMessage } from "vee-validate";
import DeleteModal from "@/components/DeleteModal";

// import PhoneCode from "../../components/PhoneCodePicker/PhoneCode.vue";
export default {
  name: "AddSuccessStories",
  components: {
    Multiselect,
    ErrorMessage,
    DeleteModal,
    Form,
    Field,
    // TextModal,
    // PhoneCode,
  },
  data() {
    return {
      uuid: this.$route.params.uuid,
      offset: 0,
      file: undefined,
      groom_search_data: "",
      bride_search_data: "",
      detail: {},
      bride: {
        registration_no: "",
      },
      groom: {
        native_place_district: {
          name: "",
        },
        registration_no: "",
        groom_user_id: "",
      },
      groom_List: [],
      bride_List: [],
    };
  },
  mounted() {
    this.$helperService.showMenu("true");
    if (this.uuid) {
      this.getDetail();
    }
  },
  methods: {
    setGroom(registration_no) {
      this.groom = registration_no;
    },
    setBride(registration_no) {
      this.bride = registration_no;
    },
    searchByRefferenceId(e, type) {
      if (e && type == "GROOM") {
        this.groom_search_data = e;
        this.groom.gender = "M";
        this.getList(type);
      } else if (e && type == "BRIDE") {
        this.bride_search_data = e;
        this.bride.gender = "F";
        this.getList(type);
      }
    },
    getList(type) {
      var obj = {};
      if (type == "GROOM") {
        obj.registration_no = this.groom_search_data;
        obj.gender = "M";
      } else {
        obj.registration_no = this.bride_search_data;
        obj.gender = "F";
      }
      this.$api
        .getAPI({
          _action: "/search-by-id",
          _body: obj,
        })
        .then((res) => {
          if (type == "GROOM") {
            this.groom_List = res.list;
            for (var i in this.groom_List) {
              if (this.groom_List[i].first_name) {
                this.groom_List[i].name = this.groom_List[i].first_name;
              }
              if (this.groom_List[i].last_name) {
                this.groom_List[i].name += " " + this.groom_List[i].last_name;
              }
              if (this.groom_List[i].registration_no) {
                this.groom_List[i].name +=
                  " | " + this.groom_List[i].registration_no;
              }
            }
          } else if (type == "BRIDE") {
            this.bride_List = res.list;
            for (var j in this.bride_List) {
              if (this.bride_List[j].first_name) {
                this.bride_List[j].name = this.bride_List[j].first_name;
              }
              if (this.bride_List[j].last_name) {
                this.bride_List[j].name += " " + this.bride_List[j].last_name;
              }
              if (this.bride_List[j].registration_no) {
                this.bride_List[j].name +=
                  " | " + this.bride_List[j].registration_no;
              }
            }
          }
        })
        .catch(() => {});
    },
    showAcceptPopup() {
      this.$refs.acceptModal.showModal(
        "Accept Success Stories",
        "Are you sure you want to accept " + this.detail.custom_request_id,
        this.detail
      );
    },

    getDetail() {
      this.$api
        .getAPI({
          _action: "/success-story/" + this.uuid,
        })
        .then((res) => {
          this.detail = res;
          if (res.bride) {
            this.bride = res.bride;
          }
          if (res.groom) {
            this.groom = res.groom;
          }

          this.groom.registration_no = res.groom.registration_no;
          this.bride.registration_no = res.bride.registration_no;
          this.detail.comment = res.comment ?? "";
          if (
            this.groom &&
            this.groom.family_details &&
            this.groom.family_details.taluka
          ) {
            this.groom.city = this.groom.family_details.taluka.name;
          }
          if (
            this.bride &&
            this.bride.family_details &&
            this.bride.family_details.taluka
          ) {
            this.bride.city = this.bride.family_details.taluka.name;
          }
          // this.getList("BRIDE");
          // this.getList("GROOM");
        })
        .catch(() => {});
    },
    selectedFile(e) {
      let files = e.target.files;
      if (
        files[0].type.toLowerCase() != "image/jpeg" &&
        files[0].type.toLowerCase() != "image/png"
      ) {
        alert("Invalid file format please use jpeg or png file.");
        return;
      }
      const size = (files[0].size / 1024 / 1024).toFixed(2);
      if (size > 10) {
        alert("File must be less then 10 MB");
        return;
      }
      var tmppath = URL.createObjectURL(files[0]);
      this.file = files[0];
      document.getElementById("preview").src = tmppath;
    },
    save() {
      if (this.uuid) {
        this.$api
          .putAPI({
            _action: "/edit",
            _body: this.groom,
            _buttonId: "save-button",
          })
          .then((res) => {
            if (this.file) {
              this.uploadImage(res.uuid);
            }
            this.$router.push("success-stories");
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$router.push("success-stories");
          })
          .catch(() => {});
      } else {
        var obj = {
          comment: this.detail.comment,
        };
        if (this.groom.uuid) {
          obj.groom_user_id = this.groom.uuid;
        }
        if (this.bride.uuid) {
          obj.bride_user_id = this.bride.uuid;
        }
        this.$api
          .postAPI({
            _action: "/add-success-story",
            _body: obj,
            _buttonId: "save-button",
          })
          .then((res) => {
            if (this.file) {
              this.uploadImage(res.uuid);
            }
            this.$router.push("success-stories");
            this.$notify({
              type: "success",
              text: res.message,
            });
            this.$router.push("success-stories");
          })
          .catch(() => {});
      }
    },
    uploadImage(uuid) {
      if (!this.file) {
        this.$router.go(-1);
        return;
      }
      this.$api
        .uploadImageAPI({
          _action: "/success-story/upload-image",
          _key: "image",
          _file: this.file,
          _body: {
            uuid: uuid ? uuid : this.uuid,
          },
          _buttonId: "save-button",
        })
        .then((res) => {
          this.$router.push("/success-stories");
          this.$notify({
            type: "success",
            text: res.message,
          });
          this.file = undefined;
        });
    },
    showRejectPopup() {
      this.$refs.rejectModal.showModal(
        "Reject Success Story",
        "Are you sure you want to reject " + this.detail.custom_request_id,
        this.detail
      );
    },
    accept(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "ACCEPTED";
      }
      this.$api
        .putAPI({
          _action: "/success-story/update-status",
          _body: obj,
        })

        .then((res) => {
          if (res) {
            this.$refs.acceptModal.closeModal();
            this.$notify({
              type: "success",
              text: "Success Story accepted successfully",
            });
            this.$router.push("/success-stories");
            this.changeTab("ACCEPTED");
          }
        })
        .catch(() => {});
    },
    deleteRecord(dataObj) {
      var detail = new Proxy(dataObj, {});
      var obj = {};
      if (detail.uuid) {
        obj.uuid = detail.uuid;
        obj.status = "REJECTED";
      }
      this.$api
        .putAPI({
          _action: "/success-story/update-status",
          _body: obj,
        })
        .then((res) => {
          if (res) {
            this.$refs.rejectModal.closeModal();
            this.$notify({
              type: "success",
              text: "Success Story rejected successfully",
            });
            this.$router.go(-1);
            this.getList(0);
          }
        })
        .catch(() => {
          this.$refs.rejectModal.removeLoader();
        });
    },
  },
};
</script>
<style src="@vueform/multiselect/themes/default.css"></style>
<style scoped>
.multiselect {
  background: #fff;
  border-radius: 8px;
  border: 1px solid !important;
}

.multiselect-tag {
  background: #9cc338 !important;
}
</style>
